<p>camera works!</p>
